import DefaultLayout from '../layouts/defaultLayout';
import { Box, Button, IconButton, Skeleton, Tab, Tabs, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import { showToast } from '../utils/toast';
import { IS_DEMO } from '../utils/config';

const tabs = ['All users', 'Free users', 'Paid users'];

export default function SendNotification() {
  const [tab, setTab] = useState(tabs[0]);
  const [title, setTitle] = useState('');
  const [subtitle, setSubtitle] = useState('');
  // const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);

  async function send() {
    if (IS_DEMO) {
      return showToast({
        type: 'error',
        message: 'This is a demo version. You cannot send notifications.'
      });
    }
    setLoading(true);

    function getTopic(key) {
      switch (key) {
        case 'All users':
          return 'all';
        case 'Free users':
          return 'free';
        case 'Paid users':
          return 'paid';

        default:
          return '';
      }
    }

    try {
      await fetch(
        'CLOUD_FUNCTION_URL',

        {
          method: 'POST',
          headers: {
            headers: { 'Content-type': 'text/plain' }
          },
          body: JSON.stringify({
            topic: getTopic(tab),
            title: title ?? '',
            body: subtitle ?? ''
          })
        }
      );

      showToast({ type: 'success', message: 'Notification sent successfully' });
      setLoading(false);
      setTitle('');
      setSubtitle('');
    } catch (error) {
      
      showToast({ type: 'error', message: 'Unable to send.' });
      setLoading(false);
      setTitle('');
      setSubtitle('');
    }
  }

  return (
    <DefaultLayout>
      {loading ? (
        <Box maxWidth="890px" display="flex" flexDirection="column">
          <Typography color="primary.main" variant="h4" fontWeight={400}>
            Send Notification
          </Typography>
          <Skeleton height={'800px'}></Skeleton>
        </Box>
      ) : (
        <Box display="flex" flexDirection="column" gap={3}>
          <Typography color="primary.main" variant="h4" fontWeight={400}>
            Send Notification
          </Typography>
          <Box color="common.white" maxWidth="900px">
            <Tabs
              textColor="inherit"
              variant="fullWidth"
              value={tab}
              onChange={(_, value) => setTab(value)}>
              {tabs.map((value, index) => (
                <Tab
                  sx={{
                    backgroundColor: value === tab ? 'primary.main' : '#C1C1C1',
                    marginRight: index + 1 === tabs.length ? 0 : 3
                  }}
                  value={value}
                  label={value}
                  key={value}
                />
              ))}
            </Tabs>
          </Box>
          <Box maxWidth="590px" display="flex" flexDirection="column" gap={2}>
            <Typography variant="body1">Title</Typography>
            <TextField value={title} onChange={(e) => setTitle(e.target.value)} size="small" />
          </Box>
          <Box maxWidth="590px" display="flex" flexDirection="column" gap={2}>
            <Typography variant="body1">Subtitle</Typography>
            <TextField
              multiline
              minRows={5}
              value={subtitle}
              onChange={(e) => setSubtitle(e.target.value)}
              size="small"
            />
          </Box>
          {/* <Box maxWidth="590px" display="flex" flexDirection="column" gap={2}>
          <Typography variant="body1">Image (optional)</Typography>
          <Box display="flex" alignItems="center" gap={2}>
            <Button fullWidth sx={{ textAlign: 'start' }} variant="outlined" component="label">
              <input
                accept="image/*"
                type="file"
                onChange={(e) => setImage(URL.createObjectURL(e.target.files[0]))}
                hidden
              />
              Choose a file
            </Button>
            <IconButton onClick={() => setImage(null)}>
              <DeleteIcon />
            </IconButton>
          </Box>
          {image && (
            <Box>
              <img src={image} alt="" />
            </Box>
          )}
        </Box> */}
          <Box maxWidth="590px" display="flex" flexDirection="column" gap={2}>
            <Button onClick={send} sx={{ color: 'white' }} color="success" variant="contained">
              Send
            </Button>
          </Box>
        </Box>
      )}
    </DefaultLayout>
  );
}
